import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * App-wide toast surface. Mounted once at the root; fire toasts anywhere with
 * `import { toast } from "sonner"`. Styled to the BOI brand tokens so toasts
 * match the rest of the shell rather than sonner's default palette.
 */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-warm-gray-02 group-[.toast]:text-muted",
          error: "group-[.toaster]:border-destructive/40",
        },
      }}
      {...props}
    />
  );
}
